import jsPDF from 'jspdf'
import type { ImageBase64 } from '../../api/utils/types'
import html2canvas from 'html2canvas'
import { BaseSize, Orientation } from './types'

export async function addImage(
    doc: jsPDF,
    elementRenderImages: HTMLElement,
    imageData: ImageBase64,
    sizePx: BaseSize,
    sizeIn: BaseSize,
    alias = 'image',
    orientation: Orientation = 'p'
) {
    const img = new Image()
    img.src = imageData?.data
    img.style.border = 'solid 1px red'
    
    switch (orientation) {
        case 'l':
            await doc.addImage(
                img,
                'png',
                sizeIn.height + sizeIn.y,                
                sizeIn.width - sizeIn.height,
                sizeIn.width,
                sizeIn.height,
                alias,
                'FAST',
                90
            )
            break
        case 'p':
            await doc.addImage(img, 'png', sizeIn.x, sizeIn.y, sizeIn.width, sizeIn.height, alias, 'FAST')
        default:
            break
    }
}

export async function renderAndAddImage(
    doc: jsPDF,
    elementRenderImages: HTMLElement,
    imageData: ImageBase64,
    sizePx: BaseSize,
    sizeIn: BaseSize,
    alias = 'image'
) {
    const imgContent = document.createElement('img')

    imgContent.width = sizePx.width
    imgContent.height = sizePx.height
    imgContent.style.objectFit = 'cover'

    elementRenderImages.appendChild(imgContent)

    await new Promise(resolve => {
        imgContent.src = imageData?.data
        imgContent.onload = resolve
    })

    const contentCanvas = await html2canvas(imgContent, {
        useCORS: true,
        imageTimeout: 30000,
        height: sizePx.height,
        width: sizePx.width,
        scale: 1
    })

    await doc.addImage(imgContent, 'png', sizeIn.x, sizeIn.y, sizeIn.width, sizeIn.height, alias, 'MEDIUM')

    imgContent.remove()
    contentCanvas.remove()
}
